module.exports = __webpack_public_path__ + "media/Images/tpa-faq-image1-0b554d23dce1836079e2295b2845e35e.jpg";